import React, {useEffect} from 'react';
import '../styles/Pages.css';

const DoceVenttura = () => {
    const images = [
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/04e98e183752027.65a1776e16674.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/f07c4b183752027.654525b8878df.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/75c6bf183752027.654525b882ab0.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/ed16c2183752027.656f864211174.gif',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/edc60e183752027.654525b884356.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/2b1f69183752027.656f864210045.gif',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/4d9000183752027.654525b899379.jpg',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/15e1f2183752027.65a080d94abc0.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/b010fa183752027.656f8642122c5.gif',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/5f0471183752027.654525b886d3d.jpg',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/862a88183752027.654525b87e206.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/23f088183752027.65a080d94c8f9.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/94d5b6183752027.65a080d94bc07.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/4d1ba6183752027.65a080d949eb8.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/17e5ae183752027.654525b87f42e.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/12d983183752027.654525b888878.jpg',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/ebc0a7183752027.65a080d948e4d.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/1ae7f1183752027.654525b89521a.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/1400/2edd15183752027.654525b880573.png'
    ];

    useEffect(() => {
        window.scrollTo(0, 0);

            // Adicionar o Google Analytics
        const gtagScript = document.createElement('script');
        gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=G-ETQFHX8NN9';
        gtagScript.async = true;
        document.head.appendChild(gtagScript);

        const gtagConfigScript = document.createElement('script');
        gtagConfigScript.innerHTML = `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'G-ETQFHX8NN9');
        `;
        document.head.appendChild(gtagConfigScript);

        return () => {
            // Cleanup quando o componente for desmontado (opcional)
            document.head.removeChild(gtagScript);
            document.head.removeChild(gtagConfigScript);
        };

      }, []);

    return (
        <div className="pages-container">
            <div className="pages-text">
                <div className="pages-left">
                    <h1>Doce Venttura</h1>
                    <p className="subtitle">Colocamos no pote sua vontade de comer doce!</p>
                </div>
                <div className="pages-right">
                    <p className="description">
                        Doce Venttura é uma confeitaria caseira que busca satisfazer o desejo das pessoas de experimentarem um doce de maneira simples e delicada.<br />

                        O objetivo da marca é produzir emoções por meio de sabores impactantes, suaves e amáveis, com diferentes cores e tons. O logotipo, com linhas simples e pontas arredondadas, busca destacar sensações de gentileza, simpatia e delicadeza, o que reforça exatamente a mensagem que a marca quer transmitir: um produto feito com cuidado e amor. Já a estampa, explora as cores da identidade visual por meio de ilustrações que reafirmam a divertida viagem gerada pelos sabores da Doce Venttura.
                    </p>
                </div>
            </div>

            <div className="pages-panel">
                {images.map((url, index) => (
                    <img key={index} src={url} alt={`Centro de Convivência Imagem ${index + 1}`} className="pages-image" />
                ))}
            </div>
        </div>
    );
};

export default DoceVenttura;
